var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCardAssignments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "409px",
    height: "320px",
    viewBox: "0 0 409 320",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M196.329,62.591 L4.82,62.591 C4.82,62.591 -5.566,49.453 4.82,40.612 C10.551,35.733 17.319,36.239 22.235,37.672 C25.438,38.606 28.632,36.445 29.335,33.183 C30.5,27.782 34.089,20.713 44.397,16.537 C54.54,12.428 60.955,18.703 64.666,25.148 C65.888,27.27 69.139,26.951 69.875,24.618 C73.091,14.44 84.294,0.949 121.106,0.949 C167.928,0.949 162.725,25.84 158.541,36.185 C157.813,37.981 159.352,39.843 161.247,39.438 C168.469,37.894 181.874,35.893 187.886,40.612 C196.329,47.24 196.329,62.591 196.329,62.591",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50.0006489%",
    x2: "0%",
    y2: "50.0006489%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "path-4",
    points: "2.711 7.434 0.436 0.45 32.905 4.604 2.711 7.434"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-6",
    points: "26.905 0.604 0.721 8.855 4.623 18.922 26.905 0.604"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.906,33.289 C95.906,33.289 90.01,25.361 90.01,16.786 C90.01,8.211 95.579,1.311 95.579,1.311 L95.579,0.698 L17.764,0.698 C8.303,0.698 0.563,7.602 0.563,16.041 L0.563,18.752 C0.563,27.191 8.303,34.096 17.764,34.096 L95.579,34.096 L95.906,33.892 L95.906,33.289 L95.906,33.289 Z",
    id: "path-8"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "path-10",
    points: "11.771 31.393 0.472 31.351 0.585 0.685 11.884 0.727 11.771 31.393"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50.0677714%",
    y1: "0.0651296079%",
    x2: "49.9304133%",
    y2: "99.9319396%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.497,68 C11.215,66.688 8.728,65.906 6.007,65.723 C4.25,65.688 2.517,65.531 0.796,65.274 L0.527,65.211 L25.875,0.057 C42.752,7.965 50.843,27.713 43.985,45.339 C38.85,58.541 26.729,66.951 13.497,68",
    id: "path-13"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "50.0007359%",
    x2: "100.000113%",
    y2: "50.0007359%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D4EBDE",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0DCDF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MD-/-Vector-/-Calendar",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shutterstock_1297562278"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.633,109.984 C142.633,109.984 166.111,36.602 122.724,0.491 C37.875,47.759 84.587,131.081 84.587,131.081 L142.633,109.984",
    id: "Fill-4",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.724,0.491 C122.429,0.656 122.141,0.822 121.849,0.988 L116.662,91.621 L76.173,52.045 C75.97,52.643 75.776,53.24 75.589,53.838 L116.534,93.86 L115.037,120.014 L116.766,119.385 L119.75,67.25 L148.038,50.609 C147.961,50.003 147.882,49.397 147.795,48.79 L119.866,65.219 L123.53,1.19 C123.26,0.958 123,0.721 122.725,0.491 L122.724,0.491",
    id: "Fill-5",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.572,93.18 C122.572,93.18 95.118,21.42 41.512,14.398 C2.664,66.531 54.223,118.695 54.223,118.695 L116.186,144.677 L122.572,93.18",
    id: "Fill-6",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.07,45.02 L77.626,75.389 L42.776,14.588 C42.355,14.524 41.937,14.453 41.512,14.398 C41.359,14.603 41.22,14.808 41.07,15.013 L59.735,47.577 L28.723,41.245 C28.655,41.538 28.597,41.829 28.533,42.121 L28.374,42.899 L60.855,49.532 L91.96,103.8 L37.178,94.421 C37.51,95.06 37.845,95.691 38.182,96.31 L93.051,105.703 L115.139,144.238 L116.186,144.677 L116.391,143.02 L78.632,77.144 L94.269,46.397 C93.874,45.937 93.474,45.478 93.07,45.02",
    id: "Fill-7",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.224,125.038 C104.224,125.038 50.86,89.472 15.622,114.236 C20.712,202.038 132.757,201.763005 132.757,201.763005 L104.224,125.038",
    id: "Fill-8",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.622,114.237 C15.642,114.576 15.668,114.909 15.69,115.245 L91.454,157.707 L47.654,175.498 C48.18,175.897 48.71,176.29 49.244,176.678 L93.343,158.766 L122.935,175.351 L122.023,172.899 L64.41,140.609 L54.484,106.063 C53.878,105.988 53.272,105.919 52.664,105.857 L62.311,139.433 L16.41,113.708 C16.148,113.884 15.884,114.053 15.622,114.235 L15.622,114.237",
    id: "Fill-9",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-12",
    transform: "translate(135.000000, 23.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-11"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.329,62.591 L4.82,62.591 C4.82,62.591 -5.566,49.453 4.82,40.612 C10.551,35.733 17.319,36.239 22.235,37.672 C25.438,38.606 28.632,36.445 29.335,33.183 C30.5,27.782 34.089,20.713 44.397,16.537 C54.54,12.428 60.955,18.703 64.666,25.148 C65.888,27.27 69.139,26.951 69.875,24.618 C73.091,14.44 84.294,0.949 121.106,0.949 C167.928,0.949 162.725,25.84 158.541,36.185 C157.813,37.981 159.352,39.843 161.247,39.438 C168.469,37.894 181.874,35.893 187.886,40.612 C196.329,47.24 196.329,62.591 196.329,62.591",
    id: "Fill-10",
    fill: "url(#linearGradient-3)",
    mask: "url(#mask-2)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-13",
    fill: "#FFFFFE",
    points: "243.952 54.242 262.07 40.647 271.814 37.233 279.547 37.285 243.952 54.242"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-14",
    fill: "#A0D2BB",
    points: "243.952 54.242 279.4 39.627 279.547 37.285"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-15",
    fill: "#5BBDB7",
    points: "281.336 45.79 281.299 45.873 280.557 51.799 244.046 54.23 281.336 45.79"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-16",
    fill: "#FFFFFE",
    points: "287.889 41.458 282.044 37.936 244.183 54.147 277.924 48.385 287.889 41.458"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.833,102.711 C379.572,102.457 378.31,102.107 377.08,101.672 C376.798,101.573 376.492,101.721 376.392,102.001 C376.292,102.282 376.439,102.59 376.721,102.69 C377.996,103.141 379.31,103.504 380.62,103.769 C381.095,103.865 381.57,103.949 382.047,104.022 C382.222,104.049 382.39,103.989 382.507,103.874 C382.587,103.794 382.644,103.69 382.661,103.571 C382.707,103.276 382.505,103.001 382.21,102.956 C381.751,102.885 381.292,102.803 380.833,102.711",
    id: "Fill-17",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.075,35.968 C296.438,36.417 294.74,36.934 292.887,37.553 C292.604,37.648 292.453,37.952 292.546,38.235 C292.641,38.518 292.946,38.671 293.229,38.577 C295.063,37.964 296.742,37.452 298.359,37.01 C298.452,36.984 298.531,36.937 298.596,36.874 C298.73,36.742 298.791,36.542 298.738,36.347 C298.659,36.059 298.362,35.89 298.075,35.968",
    id: "Fill-18",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.044,35.127 C307.16,35.013 307.223,34.846 307.201,34.672 C307.161,34.377 306.891,34.169 306.595,34.208 C304.879,34.433 303.076,34.759 301.238,35.175 C300.947,35.241 300.765,35.531 300.832,35.821 C300.898,36.112 301.187,36.294 301.478,36.228 C303.283,35.818 305.052,35.499 306.736,35.277 C306.856,35.261 306.963,35.207 307.044,35.127",
    id: "Fill-19",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.62,97.717 C369.38,97.54 369.042,97.584 368.866,97.833 C368.69,98.072 368.741,98.41 368.982,98.586 C370.454,99.669 372.035,100.623 373.68,101.419 C373.89,101.521 374.135,101.474 374.293,101.319 L374.4,101.169 C374.529,100.901 374.418,100.579 374.149,100.449 C372.565,99.68 371.041,98.761 369.62,97.717",
    id: "Fill-20",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.198,96.461 C367.4,96.242 367.386,95.901 367.167,95.699 C366.813,95.372 366.467,95.038 366.13,94.695 C365.227,93.776 364.385,92.793 363.627,91.773 C363.449,91.534 363.112,91.483 362.873,91.661 C362.641,91.836 362.582,92.178 362.761,92.416 C363.547,93.476 364.422,94.497 365.36,95.452 C365.71,95.808 366.068,96.155 366.437,96.492 C366.648,96.688 366.976,96.681 367.18,96.48 L367.198,96.461",
    id: "Fill-21",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.687,89.859 L361.792,89.778 C361.964,89.609 362.007,89.338 361.879,89.121 C361.028,87.668 360.267,86.107 359.551,84.348 C359.439,84.072 359.124,83.939 358.849,84.051 C358.574,84.163 358.439,84.479 358.552,84.754 C359.286,86.563 360.071,88.169 360.948,89.666 C361.098,89.923 361.43,90.009 361.687,89.859",
    id: "Fill-22",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.122,46.258 C341.644,46.739 342.152,47.232 342.649,47.737 C343.398,48.499 344.123,49.295 344.804,50.104 C344.996,50.332 345.336,50.361 345.564,50.169 L345.596,50.141 C345.794,49.946 345.813,49.626 345.629,49.41 C344.932,48.58 344.188,47.763 343.419,46.981 C342.91,46.463 342.388,45.957 341.853,45.465 C341.634,45.264 341.305,45.245 341.09,45.497 C340.889,45.716 340.902,46.057 341.122,46.258",
    id: "Fill-23",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.764,52.626 C347.8,54.076 348.74,55.598 349.558,57.149 C349.696,57.414 350.023,57.515 350.287,57.376 L350.413,57.283 C350.579,57.121 350.626,56.862 350.513,56.648 C349.673,55.052 348.707,53.488 347.642,51.998 C347.468,51.755 347.131,51.7 346.889,51.873 C346.649,52.043 346.59,52.383 346.764,52.626",
    id: "Fill-24",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.319,41.139 C335.836,42.064 337.307,43.088 338.691,44.184 C338.906,44.355 339.213,44.334 339.403,44.147 L339.449,44.095 C339.634,43.862 339.595,43.523 339.361,43.338 C337.942,42.215 336.435,41.165 334.883,40.218 C334.628,40.063 334.295,40.141 334.141,40.398 C333.985,40.652 334.066,40.983 334.319,41.139",
    id: "Fill-25",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.616,36.441 C323.81,36.497 324.009,36.439 324.143,36.307 C324.207,36.244 324.256,36.164 324.283,36.07 C324.365,35.784 324.198,35.485 323.911,35.404 C322.153,34.903 320.357,34.515 318.574,34.248 C318.277,34.205 318.005,34.408 317.961,34.702 C317.917,34.997 318.12,35.271 318.415,35.315 C320.152,35.575 321.902,35.954 323.616,36.441",
    id: "Fill-26",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.693,73.735 C355.789,73.71 355.871,73.662 355.937,73.598 C356.068,73.468 356.131,73.271 356.08,73.078 L355.91,72.417 C355.516,70.893 355.122,69.367 354.7,67.852 C354.62,67.564 354.322,67.396 354.036,67.476 C353.749,67.557 353.581,67.853 353.66,68.141 C354.08,69.65 354.473,71.169 354.865,72.687 L355.036,73.348 C355.11,73.637 355.405,73.81 355.693,73.735",
    id: "Fill-27",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.532,39.574 C331.744,39.683 331.995,39.638 332.156,39.479 L332.259,39.34 C332.395,39.076 332.291,38.75 332.025,38.614 C330.406,37.782 328.724,37.044 327.027,36.419 C326.747,36.317 326.439,36.461 326.335,36.74 C326.232,37.019 326.375,37.33 326.655,37.433 C328.311,38.041 329.951,38.761 331.532,39.574",
    id: "Fill-28",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.242,75.824 C355.952,75.903 355.784,76.197 355.863,76.486 C356.417,78.53 356.912,80.183 357.418,81.687 C357.514,81.969 357.82,82.121 358.103,82.025 L358.309,81.899 C358.451,81.759 358.51,81.544 358.441,81.342 C357.941,79.859 357.453,78.227 356.903,76.204 C356.826,75.916 356.529,75.746 356.242,75.824",
    id: "Fill-29",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.376,103.279 C385.079,103.263 384.824,103.49 384.808,103.789 C384.791,104.085 385.02,104.34 385.317,104.356 C387.028,104.451 388.813,104.432 390.773,104.296 C390.907,104.287 391.025,104.23 391.114,104.143 C391.223,104.036 391.285,103.884 391.274,103.721 C391.254,103.423 390.996,103.199 390.699,103.22 C388.785,103.352 387.043,103.37 385.376,103.279",
    id: "Fill-30",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.208,59.328 C350.936,59.446 350.806,59.761 350.923,60.036 C351.564,61.548 352.163,63.19 352.751,65.053 C352.84,65.338 353.144,65.495 353.427,65.406 L353.644,65.276 C353.783,65.139 353.843,64.929 353.779,64.729 C353.182,62.831 352.572,61.158 351.916,59.614 C351.8,59.34 351.482,59.211 351.208,59.328",
    id: "Fill-31",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.75,33.807 C311.116,33.82 310.482,33.848 309.852,33.888 C309.556,33.908 309.328,34.163 309.347,34.461 C309.366,34.758 309.622,34.984 309.92,34.965 C310.536,34.925 311.153,34.899 311.772,34.886 C312.921,34.861 314.087,34.889 315.24,34.969 C315.4,34.98 315.55,34.92 315.655,34.815 C315.746,34.726 315.806,34.605 315.815,34.468 C315.836,34.171 315.612,33.913 315.314,33.893 C314.129,33.81 312.93,33.782 311.75,33.807",
    id: "Fill-32",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-33",
    fill: "#A0D2BB",
    points: "9.711 179.434 6.066 186.602 13.721 184.855 39.905 176.604 9.711 179.434"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-34",
    fill: "#5BBDB7",
    points: "6.066 186.602 19.069 185.794 15.883 184.174 6.066 186.602"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-37",
    transform: "translate(7.000000, 172.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-36"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-35",
    mask: "url(#mask-5)",
    points: "2.711 7.434 0.436 0.45 32.905 4.604 2.711 7.434"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(13.000000, 176.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-39"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-38",
    mask: "url(#mask-7)",
    points: "26.905 0.604 0.721 8.855 4.623 18.922 26.905 0.604"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M8.938,193.815 L8.753,193.672 C8.531,193.417 8.558,193.031 8.813,192.809 C9.617,192.109 10.483,191.484 11.387,190.954 C11.678,190.781 12.052,190.879 12.224,191.172 C12.395,191.463 12.297,191.838 12.006,192.009 C11.167,192.501 10.363,193.08 9.616,193.731 C9.422,193.9 9.153,193.925 8.938,193.815",
    id: "Fill-41",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.446,209.98 C24.328,209.921 24.228,209.821 24.169,209.692 C24.027,209.385 24.161,209.021 24.467,208.881 C26.458,207.963 28.807,207.741 30.913,208.274 C31.238,208.358 31.438,208.689 31.355,209.018 C31.273,209.345 30.94,209.543 30.612,209.46 C28.8,209.002 26.695,209.2 24.98,209.991 C24.803,210.072 24.607,210.063 24.446,209.98 Z M35.076,216.928 C34.827,216.802 34.689,216.517 34.76,216.235 C35.125,214.771 34.992,213.422 34.363,212.224 C34.14,211.802 33.858,211.413 33.524,211.069 C33.289,210.827 33.294,210.439 33.537,210.204 C33.778,209.969 34.167,209.974 34.401,210.217 C34.817,210.645 35.169,211.128 35.445,211.654 C36.208,213.106 36.381,214.793 35.946,216.531 C35.865,216.859 35.532,217.059 35.205,216.977 L35.076,216.928 Z M3.545,201.97 C3.278,201.834 3.145,201.519 3.245,201.227 C3.559,200.312 3.939,199.413 4.374,198.557 C4.902,197.519 5.519,196.529 6.207,195.615 C6.41,195.345 6.792,195.288 7.063,195.494 C7.333,195.697 7.387,196.081 7.184,196.351 C6.539,197.208 5.96,198.137 5.465,199.111 C5.055,199.917 4.698,200.762 4.402,201.624 C4.292,201.943 3.944,202.113 3.624,202.004 L3.545,201.97 Z M17.505,216.836 L17.451,216.805 C17.166,216.621 17.085,216.243 17.268,215.959 C18.643,213.826 19.909,212.267 21.255,211.052 C21.506,210.826 21.893,210.848 22.119,211.097 C22.345,211.347 22.326,211.733 22.075,211.96 C20.811,213.101 19.611,214.582 18.296,216.621 C18.124,216.888 17.781,216.977 17.505,216.836 Z M28.806,224.199 C28.695,224.143 28.6,224.052 28.539,223.933 C28.385,223.632 28.504,223.264 28.805,223.109 C29.262,222.875 29.708,222.616 30.132,222.342 C31.334,221.56 32.418,220.525 33.262,219.351 C33.459,219.076 33.843,219.014 34.116,219.21 C34.39,219.407 34.453,219.79 34.255,220.063 C33.323,221.362 32.127,222.504 30.798,223.367 C30.341,223.665 29.857,223.945 29.362,224.198 C29.181,224.291 28.974,224.285 28.806,224.199 Z M2.727,211.72 C2.561,211.636 2.435,211.477 2.4,211.279 C2.04,209.218 2.019,207.082 2.34,204.932 C2.39,204.598 2.701,204.367 3.036,204.417 C3.37,204.466 3.6,204.778 3.55,205.112 C3.248,207.132 3.267,209.136 3.605,211.068 C3.664,211.401 3.441,211.719 3.108,211.776 C2.973,211.8 2.84,211.777 2.727,211.72 Z M19.212,225.979 C18.997,225.868 18.858,225.637 18.879,225.381 C18.909,225.045 19.205,224.795 19.541,224.823 C21.581,224.997 23.576,224.843 25.471,224.361 C25.797,224.277 26.131,224.476 26.214,224.805 C26.297,225.132 26.099,225.464 25.771,225.548 C23.744,226.062 21.612,226.228 19.437,226.042 L19.212,225.979 Z M7.121,220.406 L6.96,220.287 C6.028,219.33 5.218,218.277 4.553,217.157 C4.139,216.46 3.77,215.722 3.459,214.962 C3.331,214.649 3.48,214.292 3.792,214.164 C4.106,214.034 4.462,214.186 4.59,214.497 C4.879,215.201 5.221,215.887 5.605,216.533 C6.221,217.57 6.972,218.546 7.836,219.435 C8.072,219.677 8.066,220.063 7.824,220.299 C7.632,220.486 7.347,220.521 7.121,220.406 Z M12.648,225.442 C12.351,225.291 12.229,224.928 12.377,224.627 C12.443,224.493 12.509,224.359 12.577,224.226 C11.646,223.795 10.749,223.293 9.906,222.731 C9.626,222.544 9.549,222.164 9.737,221.883 C9.925,221.603 10.304,221.522 10.586,221.714 C11.387,222.249 12.244,222.727 13.133,223.135 C13.789,221.873 14.512,220.564 15.332,219.154 C15.502,218.861 15.88,218.765 16.168,218.933 C16.46,219.103 16.56,219.477 16.39,219.769 C15.6,221.129 14.899,222.394 14.264,223.61 C14.835,223.83 15.418,224.022 16.009,224.186 C16.34,224.281 16.525,224.614 16.435,224.939 C16.344,225.265 16.007,225.455 15.682,225.365 C15.011,225.179 14.35,224.958 13.704,224.705 C13.627,224.858 13.55,225.013 13.475,225.167 C13.325,225.47 12.959,225.595 12.656,225.446 L12.648,225.442 Z M9.097,234.653 C8.845,234.525 8.707,234.235 8.783,233.951 C9.286,232.054 9.972,230.063 10.823,228.033 C10.953,227.721 11.312,227.574 11.623,227.705 C11.924,227.826 12.082,228.194 11.951,228.506 C11.122,230.484 10.454,232.421 9.965,234.265 C9.879,234.591 9.544,234.785 9.217,234.699 L9.097,234.653 Z M8.049,244.438 C7.863,244.343 7.731,244.158 7.715,243.936 L7.697,243.64 C7.594,241.694 7.699,239.676 8.01,237.641 C8.061,237.306 8.373,237.076 8.706,237.128 C9.04,237.176 9.269,237.491 9.219,237.824 C8.92,239.779 8.819,241.714 8.919,243.573 L8.936,243.849 C8.96,244.185 8.706,244.478 8.369,244.502 C8.254,244.51 8.144,244.486 8.049,244.438 Z M10.904,253.817 C10.801,253.765 10.711,253.683 10.65,253.574 C9.603,251.731 8.814,249.754 8.307,247.696 C8.226,247.368 8.426,247.036 8.754,246.955 C9.081,246.875 9.414,247.074 9.495,247.402 C9.976,249.352 10.722,251.225 11.713,252.97 C11.88,253.264 11.777,253.637 11.483,253.804 C11.298,253.909 11.081,253.907 10.904,253.817 Z M17.65,260.896 L17.616,260.878 C15.846,259.833 14.229,258.432 12.809,256.716 C12.594,256.455 12.63,256.069 12.891,255.854 C13.151,255.638 13.536,255.678 13.752,255.936 C15.081,257.543 16.59,258.852 18.238,259.824 C18.529,259.996 18.626,260.371 18.454,260.662 C18.289,260.941 17.936,261.041 17.65,260.896 L17.65,260.896 Z",
    id: "Fill-42",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.101,262.391 C20.845,262.261 20.709,261.964 20.79,261.679 C20.884,261.353 21.221,261.166 21.547,261.257 C22.485,261.525 23.452,261.688 24.422,261.742 C24.759,261.76 25.018,262.05 24.999,262.386 C24.98,262.724 24.692,262.981 24.355,262.963 C23.295,262.904 22.237,262.727 21.211,262.435 L21.101,262.391",
    id: "Fill-43",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-44",
    fill: "#A0D2BB",
    points: "82.299 293.455 334.52 293.455 334.52 86.103 82.299 86.103"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.385,276.469 L319.242,276.469 L319.242,126.891 L97.385,126.891 L97.385,276.469 Z M331.191,76.462 L85.632,76.462 C84.095,77.315 82.953,78.612 82.519,80.143 L82.299,80.143 L82.299,297.935 L334.52,297.935 L334.52,80.143 L334.312,80.143 C333.874,78.612 332.729,77.315 331.191,76.462 L331.191,76.462 Z",
    id: "Fill-45",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-46",
    fill: "#21837F",
    points: "117.608 150.249 139.759 150.249 139.759 143.257 117.608 143.257"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-47",
    fill: "#EE9E35",
    points: "168.417 150.249 190.57 150.249 190.57 143.257 168.417 143.257"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-48",
    fill: "#21837F",
    points: "222.293 150.249 244.443 150.249 244.443 143.257 222.293 143.257"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-49",
    fill: "#21837F",
    points: "275.632 150.249 297.782 150.249 297.782 143.257 275.632 143.257"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-50",
    fill: "#FFFFFE",
    points: "118.328 200.803 140.473 200.803 140.473 185.921 118.328 185.921"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-51",
    fill: "#FFFFFE",
    points: "169.136 200.803 191.284 200.803 191.284 185.921 169.136 185.921"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-52",
    fill: "#FFFFFE",
    points: "223.007 200.803 245.151 200.803 245.151 185.921 223.007 185.921"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-53",
    fill: "#FFFFFE",
    points: "276.349 200.803 298.499 200.803 298.499 185.921 276.349 185.921"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-54",
    fill: "#FFFFFE",
    points: "118.229 236.797 140.38 236.797 140.38 221.913 118.229 221.913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-55",
    fill: "#FFFFFE",
    points: "169.041 236.797 191.191 236.797 191.191 221.913 169.041 221.913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-56",
    fill: "#FFFFFE",
    points: "222.909 236.797 245.06 236.797 245.06 221.913 222.909 221.913"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-57",
    fill: "#FFFFFE",
    points: "276.253 236.797 298.403 236.797 298.403 221.913 276.253 221.913"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M271.012,88.051 C273.753,88.051 275.976,85.579 275.976,82.529 L275.976,73.188 C275.976,68.838 273.752,65.306 271.008,65.306 C268.269,65.306 266.045,68.838 266.045,73.188 L266.045,82.529 C266.045,85.579 268.268,88.051 271.009,88.051 L271.012,88.051",
    id: "Fill-58",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.982,88.051 C230.724,88.051 232.946,85.579 232.946,82.529 L232.946,72.807 C232.946,68.456 230.72,64.928 227.975,64.928 C225.233,64.928 223.01,68.456 223.01,72.807 L223.01,82.529 C223.01,85.579 225.231,88.051 227.974,88.051 L227.982,88.051",
    id: "Fill-59",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M311.783,88.051 C314.525,88.051 316.747,85.579 316.747,82.529 L316.747,73.188 C316.747,68.838 314.523,65.306 311.785,65.306 C309.044,65.306 306.816,68.838 306.816,73.188 L306.816,82.529 C306.816,85.579 309.039,88.051 311.78,88.051 L311.783,88.051",
    id: "Fill-60",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.013,88.051 C146.755,88.051 148.977,85.579 148.977,82.529 L148.977,72.807 C148.977,68.456 146.754,64.928 144.009,64.928 C141.268,64.928 139.05,68.456 139.05,72.807 L139.05,82.529 C139.05,85.579 141.272,88.051 144.013,88.051",
    id: "Fill-61",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.74,88.051 C106.482,88.051 108.704,85.579 108.704,82.529 L108.704,73.291 C108.704,68.939 106.48,65.413 103.736,65.413 C100.994,65.413 98.773,68.939 98.773,73.291 L98.773,82.529 C98.773,85.579 100.996,88.051 103.737,88.051 L103.74,88.051",
    id: "Fill-62",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.905,88.051 C190.646,88.051 192.869,85.579 192.869,82.529 L192.869,72.807 C192.869,68.456 190.645,64.928 187.898,64.928 C185.156,64.928 182.932,68.456 182.932,72.807 L182.932,82.529 C182.932,85.579 185.154,88.051 187.896,88.051 L187.905,88.051",
    id: "Fill-63",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.061,107.677 L137.478,110.167 C136.705,110.703 135.689,110.737 134.881,110.254 L134.736,110.167 L134.12,107.677 L137.061,107.677",
    id: "Fill-64",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.106,50.075 C119.318,57.376 126.741,68.582 126.741,68.582 L120.877,66.183 L116.734,56.608 C116.734,56.608 114.895,42.775 117.106,50.075",
    id: "Fill-65",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.039,79.389 L137.663,107.9 L133.552,107.9 C133.552,107.9 124.321,82.248 123.352,74.706 C123.352,70.434 132.684,74.706 132.684,74.706 L133.039,79.389",
    id: "Fill-66",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-67",
    fill: "#EC967C",
    points: "117.728 38.555 116.194 42.525 112.874 40.122 115.115 35.44 117.728 38.555"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.979,39.213 C119.494,39.306 119.984,39.329 120.274,39.179 C122.2,37.341 121.73,31.201 121.73,31.201 L119.579,29.713 L116.189,30.956 L115.207,34.799 C114.944,35.824 115.233,36.922 115.985,37.754 C116.823,38.486 117.858,39.011 118.979,39.213",
    id: "Fill-68",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.787,32.249 C117.088,31.631 117.811,31.34 118.452,31.588 C118.919,31.769 119.483,31.958 120.042,32.075 C121.371,32.353 123.851,32.329 124.274,30.305 C124.698,28.282 122.066,28.455 122.066,28.455 L118.57,28.696 C117.535,28.768 116.506,28.558 115.555,28.144 C114.715,27.778 113.968,28.557 113.789,29.078 C113.395,30.221 113.805,32.173 114.15,33.425 C114.35,34.149 114.677,34.83 115.115,35.44 L116.787,32.249",
    id: "Fill-69",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.822,33.117 C115.173,32.918 115.718,33.083 116.038,33.487 C116.358,33.891 116.333,34.38 115.982,34.58 C115.631,34.78 115.087,34.614 114.767,34.21 C114.446,33.806 114.471,33.316 114.822,33.117",
    id: "Fill-70",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.554,109.903 C137.554,109.903 137.565,112.55 142.882,114.139 C143.973,114.465 143.618,114.788 143.823,115.246 C142.077,115.246 137.704,115.246 137.704,115.246 L135.309,112.553 L134.564,113.193 L132.836,111.496 C132.836,111.496 133.136,109.04 134.452,109.019 C135.537,109.388 137.554,109.903 137.554,109.903",
    id: "Fill-71",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.446,106.901 L121.452,109.193 C120.546,109.451 119.574,109.156 118.965,108.438 L118.856,108.309 L119.659,105.952 L122.446,106.901",
    id: "Fill-72",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.923,41.414 C116.923,41.414 117.346,40.761 113.586,38.817 C107.918,44.485 106.058,66.183 106.058,66.183 C106.058,66.183 119.31,66.183 120.877,66.183 C121.378,53.8 116.923,41.414 116.923,41.414",
    id: "Fill-73",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.566,65.596 C131.632,65.315 131.507,65.025 131.258,64.88 L128.843,63.48 C128.245,63.133 127.541,63.02 126.864,63.16 L124.245,63.265 L123.902,63.678 L123.358,65.994 C123.884,65.867 124.192,65.787 124.192,65.787 L125.855,65.833 C125.855,65.833 128.994,68.747 130.549,66.212 C130.614,68.91 131.404,68.703 131.404,68.703 L131.566,65.596",
    id: "Fill-74",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.058,66.183 L105.833,68.021 L105.825,68.095 C105.427,71.605 107.739,74.858 111.14,75.812 C111.14,75.812 117.886,78.045 126.4,78.512 C120.811,85.688 119.265,105.826 119.265,105.826 L122.866,107.133 L136.773,74.008 C137.663,71.892 136.406,69.489 134.161,69.011 L120.877,66.183 L106.058,66.183",
    id: "Fill-75",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.323,48.502 C115.323,48.502 112.563,51.028 110.94,53.619 C110.488,54.339 110.556,55.271 111.113,55.913 C114.2,59.467 125.197,62.881 125.197,62.881 L124.485,66.893 C124.485,66.893 108.879,63.823 103.351,58.279 C97.679,52.59 112.343,40.708 112.343,40.708",
    id: "Fill-76",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.126,53.736 C110.722,54.381 110.784,55.197 111.28,55.768 C112.688,57.39 116.443,59.122 119.722,60.377 C119.718,60.579 119.726,60.592 119.722,60.832 C116.28,59.539 112.484,57.827 110.947,56.057 C110.323,55.339 110.246,54.312 110.753,53.502 C112.374,50.915 115.147,48.365 115.174,48.339 L115.472,48.664 C115.444,48.689 112.715,51.201 111.126,53.736",
    id: "Fill-77",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.605,60.507 C112.599,63.742 121.381,66.059 124.517,66.714 C124.485,66.893 124.457,67.039 124.423,67.139 C121.406,66.522 112.706,64.289 106.545,61.014 C106.553,60.845 106.578,60.667 106.605,60.507",
    id: "Fill-78",
    fill: "#A0D2BB"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-79",
    fill: "#13374D",
    points: "137.396 70.434 142.016 53.919 141.168 53.682 136.763 69.43 123.501 67.125 123.352 67.993 137.396 70.434"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.672,108.686 C121.672,108.686 121.463,111.355 126.78,112.944 C127.87,113.27 127.516,113.593 127.72,114.051 C125.975,114.051 121.602,114.051 121.602,114.051 L119.207,111.358 L118.461,111.998 L116.734,110.301 C116.734,110.301 117.541,107.845 118.856,107.824 C119.941,108.193 121.672,108.686 121.672,108.686",
    id: "Fill-80",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.443,183.904 L146.522,183.904 C146.522,183.904 147.176,203.888 143.666,204.532 C140.157,205.177 138.724,203.314 138.724,203.314 C138.724,203.314 135.071,209.26 128.983,210.048 C122.895,210.835 114.443,210.979 114.443,210.979 L114.443,183.904",
    id: "Fill-81",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.01,209.862 C132.282,209.516 142.241,207.478 144.469,203.985 C141.526,205.229 138.724,203.314 138.724,203.314 C138.724,203.314 135.071,208.759 130.01,209.862",
    id: "Fill-82",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.466,174.206 C224.114,173.713 217.317,181.907 217.772,190.922 C218.231,200.027 225.375,208.245 234.481,209.552 C242.841,210.751 251.638,205.3 253.305,196.832 C255.199,187.207 248.031,178.639 238.418,178.028 C236.201,177.887 235.998,181.334 238.221,181.475 C245.852,181.96 251.558,188.754 249.865,196.407 C248.388,203.086 241.254,207.161 234.678,206.104 C227.641,204.973 222.079,198.668 221.28,191.691 C220.448,184.426 225.545,177.246 233.269,177.653 C235.485,177.77 235.691,174.323 233.466,174.206",
    id: "Fill-83",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.253,171.899 C274.906,171.304 268.021,179.423 268.376,188.441 C268.735,197.552 275.788,205.848 284.879,207.254 C293.226,208.545 302.082,203.19 303.842,194.742 C305.842,185.139 298.769,176.492 289.163,175.775 C286.947,175.61 286.706,179.055 288.928,179.22 C296.553,179.789 302.184,186.645 300.407,194.279 C298.856,200.941 291.679,204.938 285.114,203.809 C278.09,202.601 272.598,196.234 271.875,189.25 C271.123,181.976 276.299,174.852 284.018,175.344 C286.233,175.485 286.478,172.041 284.253,171.899",
    id: "Fill-84",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.821,276.419 C400.023,273.52 264.182,276.419 264.182,276.419 C257.208,276.419 250.804,284.217 250.804,291.191 C250.804,298.166 257.208,305.964 264.182,305.964 C264.182,305.964 397.002,311.544 407.89,306.123 C406.03,294.272 406.299,283.537 407.821,276.419",
    id: "Fill-85",
    fill: "#F5F4F3"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-86",
    fill: "#5BBDB7",
    points: "253.769 279.82 407.019 279.82 407.019 279.123 253.769 279.123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.777,283.537 L251.229,283.537 L251.229,284.234 L406.615,284.234 C406.658,283.996 406.716,283.766 406.777,283.537",
    id: "Fill-87",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-88",
    fill: "#5BBDB7",
    points: "249.273 290.51 406.436 290.51 406.436 289.813 249.273 289.813"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-89",
    fill: "#5BBDB7",
    points: "249.273 293.647 406.436 293.647 406.436 292.95 249.273 292.95"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.875,298.006 L250.766,298.006 L250.766,298.703 L406.976,298.703 C406.933,298.471 406.897,298.238 406.875,298.006",
    id: "Fill-90",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.641,304.106 L254.878,304.106 C255.033,304.333 255.178,304.565 255.313,304.804 L407.78,304.804 C407.724,304.572 407.679,304.34 407.641,304.106",
    id: "Fill-91",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.182,305.964 C257.208,305.964 250.804,298.166 250.804,291.191 C250.804,284.217 257.208,276.419 264.182,276.419 C264.182,276.419 399.484,273.531 407.77,276.402 C408.118,274.585 408.391,273.52 408.391,273.52 L264.99,273.52 C255.271,273.52 247.318,281.472 247.318,291.191 C247.318,300.911 255.271,308.862 264.99,308.862 C264.99,308.862 401.418,312.01 408.391,308.862 C408.391,308.596 408.168,307.617 407.869,306.133 C396.853,311.538 264.182,305.964 264.182,305.964",
    id: "Fill-92",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.898,274.071 L266.848,274.071 C261.617,274.071 257.338,269.792 257.338,264.561 L257.338,243.352 C257.338,238.121 261.617,233.841 266.848,233.841 L388.898,233.841 C394.129,233.841 398.408,238.121 398.408,243.352 L398.408,264.561 C398.408,269.792 394.129,274.071 388.898,274.071",
    id: "Fill-93",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.142,233.841 C270.414,253.956 279,274.071 279,274.071 L296.7,274.071 C296.7,274.071 290.228,251.083 297.757,233.841 C289.039,233.841 283.888,233.841 278.142,233.841",
    id: "Fill-94",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.169,233.841 C352.441,253.956 361.027,274.071 361.027,274.071 L378.728,274.071 C378.728,274.071 372.255,251.083 379.784,233.841 C371.066,233.841 365.915,233.841 360.169,233.841",
    id: "Fill-95",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.906,232.289 C392.906,232.289 387.01,224.361 387.01,215.786 C387.01,207.211 392.579,200.311 392.579,200.311 L392.579,199.698 L314.764,199.698 C305.303,199.698 297.563,206.603 297.563,215.041 L297.563,217.752 C297.563,226.191 305.303,233.096 314.764,233.096 L392.579,233.096 L392.906,232.892 L392.906,232.289",
    id: "Fill-96",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-105",
    transform: "translate(297.000000, 199.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-9",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-98"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-97",
    fill: "#5BBDB7",
    mask: "url(#mask-9)",
    points: "22.021 4.948 95.906 4.948 95.906 4.251 22.021 4.251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.029,8.665 L19.481,8.665 L19.481,9.362 L174.867,9.362 C174.91,9.123 174.968,8.893 175.029,8.665",
    id: "Fill-99",
    fill: "#5BBDB7",
    mask: "url(#mask-9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-100",
    fill: "#5BBDB7",
    mask: "url(#mask-9)",
    points: "17.525 15.638 95.906 15.638 95.906 14.94 17.525 14.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-101",
    fill: "#5BBDB7",
    mask: "url(#mask-9)",
    points: "17.525 18.775 95.906 18.775 95.906 18.078 17.525 18.078"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-102",
    fill: "#5BBDB7",
    mask: "url(#mask-9)",
    points: "22.877 21.913 95.906 21.913 95.906 21.216 22.877 21.216"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.886,25.63 L20.338,25.63 L20.338,26.327 L175.724,26.327 C175.767,26.088 175.825,25.857 175.886,25.63",
    id: "Fill-103",
    fill: "#5BBDB7",
    mask: "url(#mask-9)"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-104",
    fill: "#5BBDB7",
    mask: "url(#mask-9)",
    points: "18.383 30.637 95.906 30.637 95.906 29.939 18.383 29.939"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M359.86,200.033 L393.398,200.033 L393.398,197.382 L334.913,197.382 L334.913,200.033 L344.516,200.033 C343.51,208.171 341.167,216.845 338.562,224.475 C338.433,225.364 338.282,226.25 338.188,227.146 C338.133,227.687 338.101,228.225 338.071,228.763 C339.403,229.787 340.564,230.934 341.562,232.174 L334.913,232.174 L334.913,234.824 L393.398,234.824 L393.398,232.174 L358.908,232.174 C354.287,232.174 350.001,229.572 347.97,225.373 C346.333,221.987 345.489,218.21 345.626,214.602 C345.706,212.476 346.134,210.504 346.842,208.702 C348.934,203.381 354.197,200.033 359.86,200.033",
    id: "Fill-106",
    fill: "#E98333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.777,217.623 L342.777,214.583 C342.777,205.123 350.518,197.382 359.979,197.382 L277.412,197.382 C267.951,197.382 260.21,205.123 260.21,214.583 L260.21,217.623 C260.21,227.084 267.951,234.824 277.412,234.824 L359.979,234.824 C350.518,234.824 342.777,227.084 342.777,217.623",
    id: "Fill-107",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-108",
    fill: "#FFFFFE",
    points: "280.688 234.824 284.374 234.824 284.374 197.382 280.688 197.382"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-109",
    fill: "#A0D2BB",
    points: "287.241 234.824 289.084 234.824 289.084 197.382 287.241 197.382"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9048877,305.515 C20.888,309.972 22.797,308.671 28.945,313.615 L257.33,314.46206 C261.788,314.479 265.414,310.879 265.431,306.421 L265.48406,291.896 C265.501,287.438 261.902,283.812 257.444,283.795 L29.059,282.947969 C24.602,282.932 26.771,289.184 26.754,293.641 L20.9048877,305.515",
    id: "Fill-110",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.454,299.965 L265.431,306.421 C265.414,310.879 261.788,314.479 257.33,314.46206 L28.945,313.615 C24.488,313.599 20.928,299.059 20.928,299.059 L265.454,299.965",
    id: "Fill-111",
    fill: "#F2AE53"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.149947,306.302 L233.204,291.776 C233.221,287.318 236.847,283.719 241.305,283.734947 L257.444,283.795 C261.902,283.812 265.501,287.438 265.48406,291.896 L265.431,306.421 C265.414,310.879 261.788,314.479 257.33,314.46206 L241.191,314.402 C236.733,314.386 233.134,310.759 233.149947,306.302",
    id: "Fill-112",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-115",
    transform: "translate(227.000000, 283.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-11",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-114"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-113",
    fill: "url(#linearGradient-12)",
    mask: "url(#mask-11)",
    points: "11.771 31.393 0.472 31.351 0.585 0.685 11.884 0.727 11.771 31.393"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-116",
    fill: "#1B2441",
    points: "6.472 295.973 0.029 298.712 6.714 301.464 8.815 299.014 6.472 295.973"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.714,301.464 C7.022,300.704 7.198,299.877 7.201,299.008 L7.186,298.76 C7.169,298.263 7.1,297.78 6.98,297.316 L6.955,297.231 C6.9,297.03 6.839,296.831 6.766,296.638 C6.679,296.41 6.582,296.188 6.472,295.973 L27.955,282.944 L27.841,313.61 L6.714,301.464",
    id: "Fill-117",
    fill: "#EE9E35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.074,194.42 C354.074,194.42 353.399,195.354 350.219,196.164 C349.519,196.343 348.764,196.464 348.764,197.619 C350.249,197.619 351.903,197.619 351.903,197.619 L355.113,197.064 L355.113,197.619 L356.848,197.619 C356.848,197.619 357.33,194.783 356.317,194.42 C355.38,194.42 354.074,194.42 354.074,194.42",
    id: "Fill-118",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.909,192.383 L354.074,194.42 C354.707,194.858 355.538,194.887 356.198,194.491 L356.317,194.42 L356.317,192.383 L353.909,192.383",
    id: "Fill-119",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.179,194.826 C370.179,194.826 369.504,195.76 366.323,196.569 C365.623,196.748 364.868,196.87 364.868,198.025 C366.354,198.025 368.008,198.025 368.008,198.025 L371.218,197.47 L371.218,198.025 L372.952,198.025 C372.952,198.025 373.435,195.189 372.422,194.826 C371.484,194.826 370.179,194.826 370.179,194.826",
    id: "Fill-120",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.014,192.789 L370.179,194.826 C370.812,195.265 371.643,195.292 372.303,194.897 L372.422,194.826 L372.422,192.789 L370.014,192.789",
    id: "Fill-121",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.63,142.327 L353.411,193.488 L357.139,193.488 C357.139,193.488 362.813,152.183 361.602,142.327 C360.391,132.472 352.63,142.327 352.63,142.327",
    id: "Fill-122",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.569,142.316 C356.569,142.316 357.867,158.033 360.848,166.732 C363.828,175.432 369.21,193.488 369.21,193.488 L373.067,193.488 C373.067,193.488 366.625,155.756 368.098,142.316 L356.569,142.316",
    id: "Fill-123",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.211,116.276 C353.211,116.276 348.617,126.988 347.451,126.988 C346.519,126.988 347.801,118.241 347.801,118.241 L343.954,118.241 C343.954,118.241 339.115,133.233 342.963,135.973 C346.811,138.713 355.263,128.22 355.263,128.22 L353.211,116.276",
    id: "Fill-124",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.908,143.677 L365.517,147.119 C364.846,148.471 362.382,148.505 360.746,148.076 C360.5,148.011 360.415,147.706 360.586,147.518 C361.484,146.532 363.815,144.007 364.624,143.442 L366.908,143.677",
    id: "Fill-125",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.014,114.038 C355.513,114.051 354.081,114.795 353.315,116.087 C353.048,116.539 352.863,117.038 352.863,117.557 C352.863,119.422 352.863,142.316 352.863,142.316 L366.921,142.316 L366.921,119.167 C366.921,119.167 366.633,114.02 361.602,114.02 C359.46,114.02 357.992,114.028 357.014,114.038",
    id: "Fill-126",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-127",
    fill: "#FFFFFE",
    points: "353.097 142.327 353.097 120.089 352.63 120.105 352.63 142.327 353.097 142.327"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.154,109.296 L360.656,114.939 C360.656,114.939 359.376,115.979 357.681,115.528 C355.985,115.078 356.31,113.856 356.31,113.856 L357.271,110.239 L359.953,110.252 L362.154,109.296",
    id: "Fill-128",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.77,111.254 C356.252,111.1 355.791,110.886 355.598,110.592 C354.73,107.793 358.162,101.783 358.162,101.783 L363.364,104.213 L362.388,108.592 C362.127,109.761 361.325,110.737 360.229,111.219 C359.103,111.558 357.897,111.59 356.77,111.254",
    id: "Fill-129",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.765,103.644 C360.765,103.644 358.861,103.501 357.044,102.656 C355.227,101.81 357.005,100.032 357.005,100.032 C357.005,100.032 358.246,101.051 360.854,101.347 C362.612,101.546 363.155,101.339 364.087,102.206 C365.353,103.384 364.288,105.956 364.288,105.956 L361.977,111.38 L361.672,111.299 C361.672,111.299 362.488,107.925 362.791,106.783 C362.61,106.179 362.265,106.087 361.964,106.146 C361.638,106.21 361.391,106.48 361.305,106.801 L359.75,112.658 C359.75,112.658 355.594,113.275 354.721,112.731 C353.85,112.188 355.637,108.017 355.637,108.017 C355.637,108.017 356.857,107.833 357.452,109.007 C358.043,110.171 359.322,109.463 359.322,109.463 L360.765,103.644",
    id: "Fill-130",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.692,118.241 L344.828,117.502 C345.128,115.866 346.691,113.831 348.267,113.297 L349.899,113.297 L349.394,116.787 L347.089,118.241 L344.692,118.241",
    id: "Fill-131",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.477,106.125 C362.066,105.979 361.558,106.273 361.34,106.782 C361.121,107.291 361.276,107.822 361.687,107.968 C362.097,108.114 362.605,107.82 362.823,107.311 C363.042,106.802 362.887,106.271 362.477,106.125",
    id: "Fill-132",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.721,116.4 L345.539,118.241 L347.568,118.241 L350.936,115.423 C350.936,115.423 350.691,114.931 349.928,115.346 C349.165,115.762 348.721,116.4 348.721,116.4",
    id: "Fill-133",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.424,115.57 C365.424,115.57 373.372,124.399 373.372,129.69 C373.372,134.982 366.921,144.309 366.921,144.309 L363.734,143.376 C363.734,143.376 366.61,131.834 366.61,128.764 C366.61,125.694 360.703,121.192 360.703,121.192",
    id: "Fill-134",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.377,128.764 C366.377,131.408 364.037,141.072 363.487,143.324 C363.648,143.366 363.716,143.379 363.96,143.442 C364.636,140.661 366.844,131.362 366.844,128.764 C366.844,125.615 361.089,121.194 360.845,121.007 L360.562,121.378 C360.62,121.422 366.377,125.843 366.377,128.764",
    id: "Fill-135",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.8,111.124 C350.8,111.124 351.025,114.6 348.589,117.062 C348.438,117.213 348.201,117.313 347.958,117.315 C347.463,117.32 347.144,117.106 346.89,116.998 C346.517,116.839 346.356,116.618 346.289,116.442 C346.23,116.292 346.273,116.127 346.392,115.991 C346.896,115.411 348.482,113.399 348.126,111.398 C349.357,110.635 350.8,111.124 350.8,111.124",
    id: "Fill-136",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.614,116.843 C346.389,116.693 346.352,116.605 346.289,116.442 C346.23,116.292 346.273,116.127 346.392,115.991 C346.896,115.411 348.482,113.399 348.126,111.398 C348.562,111.128 349.021,111.017 349.437,110.983 C349.238,113.107 348.608,114.464 346.614,116.843",
    id: "Fill-137",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.578,113.688 C348.417,114.161 348.136,114.493 347.95,114.43 C347.764,114.367 347.743,113.932 347.904,113.459 C348.064,112.986 348.346,112.653 348.532,112.716 C348.718,112.78 348.738,113.214 348.578,113.688",
    id: "Fill-138",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-139",
    fill: "#EC944F",
    points: "348.568 112.735 348.373 112.663 348.375 112.766 348.503 112.835 348.568 112.735"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-140",
    fill: "#DC3F5E",
    points: "347.995 114.437 347.758 114.359 348.04 114.354 347.995 114.437"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.419,113.634 C348.259,114.107 347.978,114.439 347.791,114.376 C347.605,114.313 347.585,113.878 347.745,113.405 C347.906,112.932 348.188,112.6 348.373,112.663 C348.56,112.726 348.58,113.161 348.419,113.634",
    id: "Fill-141",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.011,108.371 L352.384,108.417 C353.099,108.507 353.613,109.137 353.528,109.818 L353.405,110.801 C353.319,111.482 352.665,111.965 351.95,111.876 L351.576,111.829 L352.011,108.371",
    id: "Fill-142",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.46,107.911 C340.124,110.594 340.468,112.847 341.229,112.942 C341.99,113.038 342.879,110.94 343.216,108.257 C343.552,105.574 343.208,103.321 342.447,103.226 C341.687,103.13 340.797,105.228 340.46,107.911",
    id: "Fill-143",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-144",
    fill: "#FFFFFE",
    points: "343.501 106.474 342.323 107.046 342.126 108.618 343.121 109.777 343.765 107.782 343.501 106.474"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.216,108.257 C343.498,106.002 343.299,104.057 342.777,103.435 L342.78,103.432 C346.931,107.297 352.224,108.433 352.224,108.433 L351.794,111.862 C351.794,111.862 344.609,110.548 341.603,112.825 L341.599,112.822 C342.259,112.35 342.933,110.513 343.216,108.257",
    id: "Fill-145",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.076,107.81 C342.021,108.246 342.044,108.607 342.126,108.618 C342.208,108.628 342.319,108.283 342.374,107.847 C342.429,107.411 342.406,107.05 342.324,107.039 C342.242,107.029 342.131,107.374 342.076,107.81",
    id: "Fill-146",
    fill: "#FACB57"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.46,115.707 C346.573,115.749 346.967,115.997 348.237,115.997 C349.163,115.997 349.579,114.859 349.737,114.241 C349.793,114.023 349.842,113.714 349.569,113.575 L348.084,113.369 L346.46,115.707",
    id: "Fill-147",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-148",
    fill: "#EC967C",
    points: "152.541 219.093 146.525 234.811 142.733 231.989 151.206 217.707 152.541 219.093"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.795,214.34 C151.416,214.808 151.222,215.398 151.251,216 L150.985,218.269 L151.295,218.62 L152.36,219.564 C152.322,219.095 152.269,219.564 152.269,219.564 L153.98,216.586 C153.98,216.586 156.05,215.259 153.44,213.301 C153.19,213.114 152.841,213.072 152.582,213.246 C151.932,213.683 151.795,214.34 151.795,214.34",
    id: "Fill-149",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.263,246.163 C143.582,240.367 146.525,234.811 146.525,234.811 L143.263,231.097 L139.263,235.76 L139.263,246.163",
    id: "Fill-150",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.867,314.288 L131.782,314.621 C132.178,312.245 138.135,300.982 138.62,295.132 C139.157,288.638 140.666,281.407 140.666,281.407 L134.259,279.502 C134.259,279.502 132.637,279.502 134.418,292.738 C130.412,297.997 129.338,309.93 129.867,314.288",
    id: "Fill-151",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.584,274.688 C134.584,274.688 136.09,283.742 138.183,293.426 C135.997,299.273 139.329,315.591 139.39,315.533 C139.641,315.297 140.792,316.715 140.792,316.715 C140.792,316.715 143.222,302.314 143.759,295.819 C144.297,289.325 144.431,281.407 144.431,281.407 L134.584,274.688",
    id: "Fill-152",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.118,314.621 C139.118,314.621 138.206,315.395 138.374,316.38 C138.541,317.366 138.777,319.675 138.777,319.675 L139.715,319.675 L139.686,317.521 C139.689,317.381 141.697,319.675 142.037,319.675 L147,319.675 C147,319.675 147.329,318.223 144.415,317.756 C141.501,317.289 139.118,314.621 139.118,314.621",
    id: "Fill-153",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.001,312.979 L131.869,315.034 C131.841,315.467 131.96,315.894 132.208,316.25 C132.48,316.644 132.939,317.183 133.699,317.801 C132.26,318.264 130.953,316.65 130.266,315.578 C129.932,315.056 129.802,314.431 129.894,313.817 L130.136,312.2 L132.001,312.979",
    id: "Fill-154",
    fill: "#EC967C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.867,314.109 C129.867,314.109 128.601,314.224 128.391,315.186 C128.181,316.148 127.583,318.096 127.583,318.096 L128.273,318.646 L129.247,316.715 C129.247,316.715 131.339,319.536 131.672,319.675 L137.088,319.675 C137.088,319.675 137.088,317.883 133.699,317.801 C130.576,317.727 129.867,314.109 129.867,314.109",
    id: "Fill-155",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-156",
    fill: "#EC967C",
    points: "140.666 237.904 136.79 237.904 138.337 233.348 141.368 235.211 140.666 237.904"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-157",
    fill: "#EE9E35",
    points: "155.111 206.945 160.297 208.965 171.452 180.328 166.266 178.308 155.111 206.945"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.902,179.335 L167.103,178.634 C167.956,177.783 169.253,177.122 169.883,177.122 C170.485,177.122 170.479,177.723 168.903,179.334 C168.903,179.334 168.902,179.334 168.902,179.335",
    id: "Fill-158",
    fill: "#BFE0CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.097,207.33 L156.029,207.303 L155.948,207.271 C155.948,207.271 165.435,180.297 167.103,178.634 L168.902,179.335 C165.681,182.627 156.147,207.201 156.097,207.33",
    id: "Fill-159",
    fill: "#F5BC6E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.05,114.593 C175.621,114.575 182.218,114.414 188.746,115.199 C189.792,115.325 194.24,115.479 191.282,115.445 C192.029,115.696 192.776,115.947 193.522,116.198 C195.914,117.965 197.941,120.076 200.517,121.631 C202.936,123.091 205.431,124.157 207.938,124.854 C216.333,134.545 219.222,148.44 214.25,161.22 C208.203,176.765 192.471,185.675 176.641,183.738 C175.472,182.983 174.209,182.354 172.833,181.877 C172.375,181.629 171.91,181.44 171.441,181.274 C169.624,180.211 167.785,179.187 165.85,178.378 C163.833,177.535 161.74,177.082 159.631,176.931 C147.039,167.574 141.696,150.642 147.659,135.314 C151.583,125.227 159.589,117.942 169.05,114.593",
    id: "Fill-160",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-163",
    transform: "translate(168.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-14",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-13"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-162"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.497,68 C11.215,66.688 8.728,65.906 6.007,65.723 C4.25,65.688 2.517,65.531 0.796,65.274 L0.527,65.211 L25.875,0.057 C42.752,7.965 50.843,27.713 43.985,45.339 C38.85,58.541 26.729,66.951 13.497,68",
    id: "Fill-161",
    fill: "url(#linearGradient-15)",
    mask: "url(#mask-14)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.396,136.768 C157.747,120.443 176.129,112.358 192.454,118.708 C208.778,125.06 216.864,143.442 210.513,159.767 C204.162,176.091 185.779,184.176 169.455,177.825 C153.131,171.475 145.045,153.092 151.396,136.768 Z M147.659,135.314 C140.505,153.702 149.613,174.408 168.001,181.563 C186.39,188.717 207.096,179.609 214.25,161.22 C221.404,142.832 212.297,122.125 193.908,114.972 C175.519,107.818 154.813,116.925 147.659,135.314 L147.659,135.314 Z",
    id: "Fill-164",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.497,235.9 L156.716,199.394 C157.072,198.479 158.053,198.008 158.906,198.341 L163.297,200.051 C164.151,200.384 164.554,201.394 164.198,202.309 L154.396,227.468 C152.936,225.194 147.583,236.596 144.497,235.9",
    id: "Fill-165",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.366,239.503 L156.716,199.394 C157.047,198.545 157.915,198.087 158.72,198.29 C158.607,199.09 148.284,229.447 143.983,242.672 C143.062,242.15 141.52,239.763 140.366,239.503",
    id: "Fill-166",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.802,133.543 C173.88,135.915 171.211,137.091 168.839,136.169 C166.467,135.248 165.292,132.578 166.213,130.207 C167.135,127.835 169.805,126.659 172.176,127.581 C174.548,128.502 175.724,131.172 174.802,133.543",
    id: "Fill-167",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.764,138.959 C165.325,140.089 164.054,140.648 162.925,140.209 C161.796,139.771 161.237,138.5 161.675,137.371 C162.114,136.242 163.385,135.683 164.514,136.121 C165.643,136.56 166.202,137.831 165.764,138.959",
    id: "Fill-168",
    fill: "#FFFFFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.815,242.804 C145.796,242.689 145.77,242.593 145.747,242.487 C149.586,237.537 152.845,234.051 152.845,234.051 L149.583,230.337 L142.166,237.379 L139.99,237.389 C139.99,237.389 137.051,235.449 134.484,238.096 C133.546,239.063 132.921,241.687 133.548,244.459 C135.275,252.104 133.923,256.147 133.923,256.147 L143.925,259.876 C143.925,259.876 144.152,253.229 144.309,248.566 L144.309,248.551 C144.34,247.641 144.643,246.773 145.121,245.999 C145.671,245.107 146.021,244.021 145.815,242.804",
    id: "Fill-169",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-170",
    fill: "#F0AB85",
    points: "158.859 218.333 152.845 234.051 149.053 231.229 157.525 216.947 158.859 218.333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.114,213.58 C157.735,214.048 157.541,214.639 157.57,215.24 L157.305,217.51 L157.614,217.86 L158.679,218.806 C158.641,218.336 158.588,218.806 158.588,218.806 L160.3,215.826 C160.3,215.826 162.369,214.499 159.759,212.542 C159.51,212.354 159.16,212.313 158.901,212.487 C158.251,212.923 158.114,213.58 158.114,213.58",
    id: "Fill-171",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.129,255.915 C144.129,255.915 145.46,262.693 145.46,266.725 C145.46,268.939 144.917,282.893 144.917,282.893 C144.917,282.893 135.415,283.581 133.569,283.581 C133.112,272.146 130.505,271.795 130.505,266.462 C130.505,264.144 131.693,261.524 132.605,259.854 C133.261,258.656 133.671,257.819 133.923,256.147 L133.985,255.931 L144.129,255.915",
    id: "Fill-172",
    fill: "#005C5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.028,225.159 L135.671,227.385 L136.298,232.13 L136.337,232.327 C136.459,232.35 136.582,232.372 136.704,232.402 L136.762,232.419 L136.82,232.431 C138.287,232.791 139.325,234.003 139.792,235.405 C140.695,235.557 141.629,235.559 142.543,235.37 C143.166,235.242 143.729,235.047 143.988,234.747 C145.33,231.82 142.028,225.159 142.028,225.159",
    id: "Fill-173",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.882,229.197 C140.17,230.034 140.574,238.854 140.278,244.86 C140.12,248.093 137.694,250.734 134.499,251.244 C132.233,251.606 129.746,251.673 128.245,250.817 C129.237,250.007 134.584,242.139 132.872,231.719 C132.646,230.348 132.619,226.53 134.928,224.458 C137.493,222.156 142.787,225.159 142.787,225.159 C142.787,225.159 144.233,228.048 141.882,229.197",
    id: "Fill-174",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.272,280.927 L66.667,280.919 C67.648,281.021 68.746,281.301 68.929,282.151 C68.929,282.151 69.058,282.716 69.036,283.278 C68.774,283.585 58.97,283.237 58.97,283.237 L58.927,283.202 C57.889,281.952 59.272,280.927 59.272,280.927",
    id: "Fill-175",
    fill: "#17324A"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-176",
    fill: "#1B2441",
    points: "69.036 283.278 58.97 283.237 59.057 283.629 69.05 283.629 69.036 283.278"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-177",
    fill: "#FFFFFE",
    points: "62.199 280.919 62.865 280.923 62.658 281.829 62.012 281.829 62.199 280.919"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-178",
    fill: "#FFFFFE",
    points: "63.627 280.919 64.293 280.923 64.085 281.829 63.439 281.829 63.627 280.919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.765,278.464 L59.272,280.927 C59.866,281.228 60.637,281.246 61.255,280.975 L61.367,280.925 L61.723,278.464 L58.765,278.464",
    id: "Fill-179",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.991,280.927 L49.385,280.919 C50.367,281.021 51.464,281.301 51.648,282.151 C51.648,282.151 51.776,282.716 51.755,283.278 C51.493,283.585 41.689,283.237 41.689,283.237 L41.646,283.202 C40.607,281.952 41.991,280.927 41.991,280.927",
    id: "Fill-180",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-181",
    fill: "#1B2441",
    points: "51.755 283.278 41.689 283.237 41.776 283.629 51.769 283.629 51.755 283.278"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-182",
    fill: "#FFFFFE",
    points: "44.918 280.919 45.584 280.923 45.376 281.829 44.731 281.829 44.918 280.919"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-183",
    fill: "#FFFFFE",
    points: "46.346 280.919 47.011 280.923 46.804 281.829 46.159 281.829 46.346 280.919"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.312,278.464 L41.991,280.927 C42.585,281.228 43.356,281.246 43.974,280.975 L44.086,280.925 L45.27,278.464 L42.312,278.464",
    id: "Fill-184",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.346,195.641 L47.257,199.61 L49.137,204.423 L49.229,204.62 C49.363,204.611 49.497,204.604 49.631,204.604 L49.697,204.606 L49.761,204.604 C51.391,204.604 52.792,205.606 53.642,206.956 C54.628,206.882 55.607,206.643 56.517,206.21 C57.136,205.915 57.676,205.565 57.871,205.185 C58.522,201.771 53.346,195.641 53.346,195.641",
    id: "Fill-185",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.091,196.885 C61.091,196.885 61.837,203.952 60.336,208.453 C61.033,209.059 63.592,211.801 64.396,208.246 C65.202,204.69 63.494,195.641 63.494,195.641 L61.091,196.885",
    id: "Fill-186",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-187",
    fill: "#1B2441",
    points: "57.438 196.385 56.005 197.307 56.517 198.376 58.054 197.698 57.438 196.385"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.594,197.671 C56.738,197.998 56.748,198.31 56.617,198.367 C56.486,198.424 56.264,198.206 56.12,197.879 C55.977,197.552 55.967,197.24 56.097,197.183 C56.229,197.125 56.451,197.344 56.594,197.671",
    id: "Fill-188",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.724,191.172 L74.73,191.132 C74.46,190.518 73.985,189.542 73.344,188.646 C72.309,187.196 72.014,186.472 72.014,186.472 L57.219,196.154 L58.177,197.962 L74.726,191.847 C74.711,191.62 74.706,191.395 74.724,191.172",
    id: "Fill-189",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-190",
    fill: "#EC967C",
    points: "52.003 206.959 51.471 210.281 56.178 210.281 56.517 206.21 52.003 206.959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.16,215.203 C64.16,215.203 69.72,213.433 71.463,211.052 C73.206,208.671 70.256,195.641 70.256,195.641 L70.638,193.295 C70.852,191.975 69.839,190.774 68.502,190.763 L67.017,190.748971 C66.398,190.744 65.981,191.379 66.232,191.944 L68.186,196.34 C68.186,196.34 69.653,206.21 67.599,206.959 C65.15,207.832 62.377,208.042 62.377,208.042 L64.16,215.203",
    id: "Fill-191",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.714,206.959 L52.284,203.787 L53.213,203.203 C53.899,202.771 54.199,201.926 53.938,201.159 L52.92,198.169 C52.92,198.169 55.817,197.814 55.729,195.115 C55.729,193.726 53.817,193.718 53.817,193.718 C53.817,193.718 53.245,194.96 51.471,195.107 C50.709,195.012 48.618,195.292 47.206,197.755 C46.258,199.411 46.674,202.006 47.5,203.952 C48.24,205.697 50.13,206.672 52.003,206.959 L53.714,206.959",
    id: "Fill-192",
    fill: "#17324A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.06,233.606 C48.06,233.606 48.355,240.37 49.818,247.701 C50.249,249.86 50.087,252.096 49.385,254.183 C46.064,264.047 41.41,278.878 41.41,278.878 L45.55,278.878 C45.55,278.878 54.932,261.35 57.349,252.654 C59.767,243.958 60.181,241.198 60.181,241.198 L57.304,233.606 L48.06,233.606",
    id: "Fill-193",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.514,202.31 C51.344,202.809 51.688,203.471 52.284,203.787 C52.879,204.103 53.5,203.954 53.67,203.454 C53.841,202.954 53.496,202.293 52.901,201.977 C52.306,201.66 51.685,201.81 51.514,202.31",
    id: "Fill-194",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.561,233.606 L48.06,233.606 L48.06,216.285 C48.06,212.491 50.948,209.32 54.726,208.968 L64.115,207.832 C64.115,207.832 65.219,209.521 68.295,213.448 C64.598,215.732 60.319,216.784 60.319,216.784 L61.561,233.606",
    id: "Fill-195",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.06,233.606 C48.06,233.606 49.967,240.508 57.002,248.243 C58.177,249.41 59.87,251.841 59.629,255.276 L58.177,278.878 L62.377,278.878 C62.377,278.878 67.496,259.279 66.392,249.617 C65.288,239.956 61.561,233.606 61.561,233.606 L48.06,233.606",
    id: "Fill-196",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.458,189.567 C73.185,191.073 74.17,192.104 74.659,191.867 C75.148,191.632 74.956,190.219 74.23,188.713 C73.504,187.206 72.519,186.177 72.029,186.412 C71.54,186.648 71.732,188.061 72.458,189.567",
    id: "Fill-197",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.508,194.002 L60.633,194.062 C61.073,194.272 61.579,194.305 62.042,194.149 L62.125,194.122 C62.887,193.868 63.482,193.265 63.726,192.499 C63.834,192.158 63.535,191.828 63.186,191.901 L62.25,192.098 C61.886,192.174 61.567,192.392 61.363,192.702 L60.508,194.002",
    id: "Fill-198",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.492,142.61 C187.678,145.729 185.865,148.847 184.051,151.966 C183.227,153.384 182.402,154.801 181.578,156.219 C181.331,156.645 181.083,157.07 180.836,157.496 C179.397,156.089 178.042,154.417 176.793,153.22 C174.109,150.646 171.424,148.073 168.739,145.5 C164.092,141.046 157.011,148.107 161.668,152.571 C165.248,156.002 168.828,159.433 172.407,162.864 C175.07,165.416 177.92,169.304 182.015,168.98 C186.068,168.66 187.875,165.287 189.718,162.116 C192.521,157.297 195.324,152.477 198.126,147.657 C201.368,142.083 192.729,137.043 189.492,142.61",
    id: "Fill-199",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.479,266.422 L199.351,271.374 C199.507,272.066 199.534,272.896 198.818,273.306 C198.818,273.306 198.346,273.582 197.837,273.757 C197.497,273.685 195.336,266.996 195.336,266.996 L195.357,266.956 C196.214,265.839 197.479,266.422 197.479,266.422",
    id: "Fill-200",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-201",
    fill: "#1B2441",
    points: "197.837 273.757 195.336 266.996 195.008 267.187 197.527 273.884 197.837 273.757"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-202",
    fill: "#FFFFFE",
    points: "198.225 268.38 198.389 268.828 197.526 268.994 197.363 268.562 198.225 268.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-203",
    fill: "#FFFFFE",
    points: "198.585 269.337 198.749 269.785 197.886 269.951 197.723 269.518 198.585 269.337"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.555,265.253 L197.479,266.422 C197.36,266.92 197.539,267.443 197.937,267.766 L198.01,267.824 L200.301,267.235 L199.555,265.253",
    id: "Fill-204",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.128,234.003 C216.128,234.003 214.069,236.22 213.539,240.122 C213.186,242.718 214.157,246.833 214.264,250.062 C214.361,253.014 213.029,255.36 210.688,257.163 L199.555,265.253 L200.301,267.235 C200.301,267.235 215.539,264.95 219.54,258.125 C223.541,251.3 224.489,235.85 224.489,235.85 L216.128,234.003",
    id: "Fill-205",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.263,225.593 L201.537,238.38 C201.537,238.38 199.183,238.654 198.163,239.557 C197.63,240.027 197.655,240.971 197.799,241.764 C197.909,242.364 198.631,242.619 199.092,242.219 C199.722,241.673 200.533,241.057 201.066,240.969 C202.478,240.733 202.9,239.732 202.9,239.732 L211.116,226.848 L207.263,225.593",
    id: "Fill-206",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.14,199.877 L239.073,197.368 L236.798,184.974 L233.269,183.169 C233.269,183.169 233.652,182.486 234.523,182.777 C235.395,183.067 236.132,182.895 236.132,182.895 C236.132,182.895 236.792,182.077 235.54,181.524 C234.837,181.051 234.366,181.521 232.327,181.443 C232.327,181.13 235.015,180.385 235.015,180.385 C235.853,180.115 237.992,181.771 237.992,181.771 C238.135,181.969 238.229,182.197 238.265,182.438 L238.603,184.738 C238.603,184.738 243.152,197.213 243.152,198.545 C243.152,199.877 240.603,201.701 240.603,201.701 L236.14,199.877",
    id: "Fill-207",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.363,235.289 C220.363,235.289 218.599,237.415 219.657,242.357 C220.334,245.512 223.303,249.481 225.296,252.216 C226.726,254.177 226.756,256.642 226.326,259.03 C224.693,268.106 227.306,279.188 227.306,279.188 L229.424,279.188 C229.424,279.188 232.602,262.949 233.543,251.535 C234.392,241.244 229.987,233.665 229.896,233.532 L220.363,235.289",
    id: "Fill-208",
    fill: "#13374D"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-209",
    fill: "#EE9E35",
    points: "232.104 182.724 238.756 183.699 239.014 181.941 232.362 180.966 232.104 182.724"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-210",
    fill: "#FFFFFE",
    points: "239.397 181.998 239.14 183.756 238.532 183.666 238.79 181.909 239.397 181.998"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.012,183.736 C239.499,183.805 239.909,183.772 240.026,182.977 C240.153,182.109 239.759,182.032 239.272,181.958 L239.012,183.736",
    id: "Fill-211",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-212",
    fill: "#FFFFFE",
    points: "232.104 182.724 230.813 181.947 230.907 181.308 232.362 180.966 232.104 182.724"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-213",
    fill: "#13374D",
    points: "230.813 181.947 230.252 181.543 230.907 181.308 230.813 181.947"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-214",
    fill: "#E98333",
    points: "238.63 182.996 238.571 183.396 232.144 182.453 232.202 182.053 238.63 182.996"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-215",
    fill: "#E98333",
    points: "238.755 182.148 238.696 182.549 232.268 181.605 232.326 181.205 238.755 182.148"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.166,210.199 C211.382,212.979 206.927,226.344 206.927,226.344 L210.249,228.208 L215.657,220.787 C215.657,220.787 216.185,229.378 214.89,235.968 C215.479,238.438 218.285,238.16 222.835,237.298 C227.385,236.435 230.365,234.474 230.365,234.474 C230.365,234.474 230.562,222.555 231.15,216.234 C231.738,209.915 230.577,209.239 232.17,209.449 C235.725,207.431 241.549,200.929 241.549,200.929 L236.14,199.877 L224.489,206.702 C224.489,206.702 218.793,208.204 215.166,210.199",
    id: "Fill-216",
    fill: "#5BBDB7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.767,194.391 L224.577,197.166 C225.771,198.345 226.273,200.054 225.91,201.691 L225.58,203.173 L221.767,194.391",
    id: "Fill-217",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.363,193.341 C211.538,193.341 214.441,206.441 214.441,206.441 C214.441,206.441 215.657,214.94 218.363,218.353 C220.706,221.307 225.341,220.418 227.536,219 C228.609,218.308 229.812,217.845 231.079,217.692 C232.939,217.469 235.151,216.647 235.151,213.293 C235.151,210.136 231.382,207.693 228.9,205.949 C227.284,204.813 226.156,203.112 225.685,201.193 C224.891,197.96 222.953,193.341 218.363,193.341",
    id: "Fill-218",
    fill: "#1B2441"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.67,281.542 L232.964,281.534 C233.667,281.632 234.452,281.898 234.584,282.713 C234.584,282.713 234.677,283.252 234.661,283.789 C234.474,284.083 227.453,283.75 227.453,283.75 L227.422,283.717 C226.679,282.521 227.67,281.542 227.67,281.542",
    id: "Fill-219",
    fill: "#21837F"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-220",
    fill: "#13374D",
    points: "234.661 283.789 227.453 283.75 227.516 284.125 234.671 284.125 234.661 283.789"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-221",
    fill: "#FFFFFE",
    points: "229.766 281.534 230.242 281.538 230.094 282.404 229.631 282.404 229.766 281.534"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-222",
    fill: "#FFFFFE",
    points: "230.787 281.534 231.265 281.538 231.116 282.404 230.653 282.404 230.787 281.534"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.306,279.188 L227.67,281.542 C228.095,281.829 228.646,281.847 229.089,281.587 L229.169,281.54 L229.424,279.188 L227.306,279.188",
    id: "Fill-223",
    fill: "#F0AB85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.523,182.777 C233.652,182.486 233.269,183.169 233.269,183.169 L235.617,184.37 L235.714,184.326 C236.1,184.17 236.901,183.823 237.269,183.76 C237.046,183.537 234.958,182.922 234.523,182.777",
    id: "Fill-224",
    fill: "#F0AB85"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardAssignments);
export default __webpack_public_path__ + "static/media/card-assignments.92c3dddef935167f6cee54af21fcfd24.svg";
export { ForwardRef as ReactComponent };